import SolutionFeaturesI18n from "@/components/landing/shared/SolutionFeaturesI18n";
import { MessageCircle, Target, Calendar, BarChart3, Layers, Palette } from "lucide-react";
const MarketingFeaturesSection = () => <SolutionFeaturesI18n translationPrefix="marketingSolution" icons={[MessageCircle, Target, Calendar, BarChart3, Layers, Palette]} />;
export default MarketingFeaturesSection;
